import { render } from "./assignRole.vue?vue&type=template&id=328c3834"
import script from "./assignRole.vue?vue&type=script&lang=js"
export * from "./assignRole.vue?vue&type=script&lang=js"

import exportComponent from "D:\\zhang\\项目\\经皮黄疸仪\\jaundiceweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__